import store from "../store";
import Cookies from 'js-cookie';
import Config from './config.js';

export default class Login {
	// 判断是否登录
	static checkLogin () {
		return JSON.stringify(store.state.safeInfo) != "{}";
	}
	
	static setSafeInfo (kj, kt) {
		let safeInfo = {
			kj,
			kt
		};
		store.commit("setSafeInfo", safeInfo);
	}
	
	static setSafeInfoCache (kj, kt) {
		let safeInfo = {
			kj,
			kt
		};
		Cookies.set('kfVisionWeb_safeInfo', JSON.stringify(safeInfo), {expires: Config.cookie_expires});
	}
	
	// 初始化判断
	static init () {
		if (Cookies.get('kfVisionWeb_safeInfo')) {
			store.commit("setSafeInfo", JSON.parse(Cookies.get('kfVisionWeb_safeInfo')));
		} else {
			Cookies.remove('kfVisionWeb_safeInfo');
		}
	}
}
 
 
 
 